<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <div class="d-inline-block align-middle me-2">
      <svg-icon src="assets/icons/icon-my-post.svg" class="icon-my-post"> </svg-icon>
    </div>

    <h1 data-test-id="page-title" class="d-inline-block align-middle m-0">
      {{ 'POSTS_TITLE_HINT' | translate }}
    </h1>
  </div>

  <div class="pb-4">
    <button
      class="btn btn-primary mt-4"
      data-test-id="item-create-btn"
      (click)="createPost()"
      type="button"
      aria-labelledby="Create button"
    >
      {{ 'BTN_CREATE_POST' | translate }}
    </button>
  </div>

  <ng-container *ngIf="page$ | async as page" ngbNavContent>
    <app-search-input
      [label]="SEARCH_INPUT_LABEL"
      [value]="page.queryKeyword"
      (valueChanged)="onKeywordChanged($event)"
    ></app-search-input>

    <ng-container *ngIf="page.mode === ListMode.BROWSE">
      <app-spinner>
        <app-items-list
          [items]="posts$ | async"
          [searchState]="{ pagination: page.pagination }"
          [type]="CardType.POST"
          [noItemsTitle]="'POSTS_NO_POSTS'"
          (pageChanged)="onPageChanged($event)"
        ></app-items-list>
      </app-spinner>
    </ng-container>

    <ng-container *ngIf="page.mode === ListMode.SEARCH">
      <div *ngIf="(searchPosts$ | async).length" class="mt-3">
        <app-sort-drop-down
          [ascending]="(sortParams$ | async).ascending"
          [currentSortCategory]="(sortParams$ | async).orderType"
          [isLoading]="isLoading$ | async"
          [sortOptions]="SORT_OPTIONS"
          (toggleSortingByType)="toggleSortingOrderByType($event)"
        >
        </app-sort-drop-down>
      </div>

      <app-spinner>
        <ng-container *ngIf="(searchPosts$ | async).length; else emptyResult">
          <app-items-list
            [items]="searchPosts$ | async"
            [type]="CardType.POST"
            [searchState]="{ pagination: page.pagination }"
            [noItemsTitle]="''"
            (pageChanged)="onPageChanged($event)"
          ></app-items-list>
        </ng-container>

        <ng-template #emptyResult>
          <p class="p-3" [innerHTML]="'SEARCH_NO_RESULT_HINT' | translate: { keyword: page.queryKeyword }"></p>
        </ng-template>
      </app-spinner>
    </ng-container>
  </ng-container>
</div>
